import OrderMinProgress from './OrderMinProgress';

export default OrderMinProgress;
